import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { HttpService } from './http.service';
import { map, Observable } from '../store';

@Injectable()
export class TokenService {
  private _url = '/api/TokenTest';

  constructor(
    private http: HttpClient,
    private httpService: HttpService
  ) { }

  // check-token-validation/{tokenValue}
  getTokenValidation(clubId: string, tokenValue: string) {
    return this.http.get<number>(this._url + '/check-token-validation/' + clubId + '/' + tokenValue);
  }

 


  getTokenValidationTest(tokenData: any) {
      console.log('TokenData - ', tokenData);
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'responseType': 'text'
        })
      };
      return this.http.post(this._url + '/check-token-validation-test', tokenData, httpOptions);
  }

  updateUserPassword(payload: any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };
    return this.http.post(this._url + '/update-user-password', payload, httpOptions);
  }

  getUserIdByTokenValue(payload: any) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };

    return this.http.post(this._url + '/get-user-id-by-token-value', payload, httpOptions);
  }

  verifyUserAccount(payload: any){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'responseType': 'text'
      })
    };

    return this.http.post(this._url + '/verify-user-account', payload, httpOptions);
  }

  validateTeamUser(tokenData: { clubId: number, teamId?: number, tokenValue: string }) {
    return this.httpService.post(`${this._url}/validate-token`, tokenData);
  }

  validateProgramID(programID: number, typeId: number): Observable<boolean> {
    const data = {
      tokenValue: localStorage.getItem('tokenValue'),
      programId: programID,
      typeId: typeId
    };

    return this.httpService.post(`${this._url}/validate-programID`, data).pipe(map(res => !!res));
  }

}



// WEBPACK FOOTER //
// ./src/app/services/token.service.ts